import { reactive } from 'vue';
import { positiveId } from './customerToolsState.mjs';

// Native dashboardApps records are global and allow stale account responses.
// Keep this account-bound collection for both existing frames and shortcuts.
export const catalogue = reactive({ account: null, ready: false, apps: [] });
let generation = 0;
export async function loadApps(accountId) {
  const account = positiveId(accountId);
  const request = ++generation;
  if (catalogue.account !== account) catalogue.apps = [];
  catalogue.account = account;
  catalogue.ready = false;
  if (!account) return;
  try {
    // Chatwoot configures authentication and API host on window.axios.
    // Raw imported axios is a different, unauthenticated instance.
    const { data } = await window.axios.get(`/api/v1/accounts/${account}/dashboard_apps`);
    if (request !== generation || catalogue.account !== account) return;
    if (!Array.isArray(data)) throw new Error('Invalid dashboard apps response');
    catalogue.apps = data;
    catalogue.ready = true;
  } catch {
    if (request === generation) { catalogue.apps = []; catalogue.ready = false; }
  }
}
export function accountApps(accountId) {
  return catalogue.account === positiveId(accountId) ? catalogue.apps : [];
}
export const TOOL_ACCOUNT = '1';
export const TOOL_IDS = ['1', '2', '3', '4', '5'];
